//
// Copyright 2021 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React from "react";
import {makeStyles} from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import * as Config from "eai-configurator-ui/components/configuration/utils/ConfigurationRegistry";
import Box from "@material-ui/core/Box";
import DataSourcesButton from "src/components/loader/buttons/DataSourcesButton";
import CopyLayoutButton from "src/components/loader/buttons/CopyLayoutButton";
import ConfigurationAsyncComboBox from "eai-configurator-ui/components/configuration/base/ConfigurationAsyncComboBox";
import TreeView from "eai-configurator-ui/components/base/TreeView";

const useStyles = makeStyles((theme) => ({
  button: {
    margin: 4,
  },
}));
const LayoutPage = ({navigateToResults}) => {
  const classes = useStyles();
  const [sourceDataSource, setSourceDataSource] = React.useState(
    Config.fromPath("loader:layout:fromDataSource", true).data.value
  );

  const [
    dataSourceRefreshCounter,
    setDataSourceRefreshCounter,
  ] = React.useState(0);

  const handleSelectSourceDataSource = (dataSourceName) => {
    setSourceDataSource(dataSourceName);
  };
  const handleCloseDataSourceDialog = (dataSourceName) => {
    setDataSourceRefreshCounter(dataSourceRefreshCounter + 1);
  };

  return (
    <React.Fragment>
      <div>
        <Typography variant="body2" color="textSecondary">
          <h5>Copy Layouts</h5>
          <hr/>
        </Typography>
        <Typography variant="caption" color="textSecondary">
          Use this dialog to submit a job to copy layouts from the 'Source Data Source' to the 'Dest Data Source'
          <br/>
          Select the 'Source Data Source' to populate the layout list
          <br/>
          <b>IMPORTANT:</b> If the layouts being copied use global, project or user filters, you <b>must</b> submit a job to copy just the filters, and then
          another job to copy the layouts
        </Typography>
        <Box m={1} display="flex" flexDirection="row" justifyContent="flex-end">
          <DataSourcesButton
            className={classes.button}
            handleClosed={handleCloseDataSourceDialog}
          />
          <CopyLayoutButton
            className={classes.button}
            handleSuccess={navigateToResults}
          />
        </Box>
        <div key={dataSourceRefreshCounter}>
          <ConfigurationAsyncComboBox
            path={"loader:layout:fromDataSource"}
            url={"loader/dataSources"}
            autoSelect={false}
            transformHttpResponse={(data) => {
              return {
                options: data.dataSources.map((dataSource) => dataSource.name),
              };
            }}
            handleChanged={handleSelectSourceDataSource}
          />
          <ConfigurationAsyncComboBox
            disabled={!Boolean(sourceDataSource)}
            path={"loader:layout:toDataSource"}
            url={"loader/dataSources"}
            autoSelect={false}
            transformHttpResponse={(data) => {
              return {
                options: data.dataSources.map((dataSource) => dataSource.name),
              };
            }}
          />
        </div>
        {sourceDataSource && (
          <TreeView
            path={"loader:layout:layout"}
            url={
              "loader/layoutTree?dataSourceName=" +
              encodeURIComponent(sourceDataSource)
            }
          />
        )}
      </div>
    </React.Fragment>
  );
};
export default LayoutPage;
